"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerIcon = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
require("../spinner.types");
const spinner_icon_styles_1 = require("./spinner-icon.styles");
const SpinnerIcon = ({ inverse, color, size }) => {
    const theme = (0, styled_components_1.useTheme)();
    const colorIcon = (0, react_1.useMemo)(() => {
        if (color)
            return color;
        if (inverse)
            return theme.colors.icon.inverse;
        return theme.colors.icon.primary;
    }, [color, inverse, theme]);
    return (react_1.default.createElement(spinner_icon_styles_1.SvgWrapper, { size: size },
        react_1.default.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5C1 4.80558 4.80558 1 9.5 1", stroke: colorIcon, strokeWidth: "1.5", strokeLinecap: "square", strokeLinejoin: "round" }))));
};
exports.SpinnerIcon = SpinnerIcon;
